/**
 * Hook pour récupérer les employés
 * @returns 
 */
import { getEmployees } from "@/services/employees.service";
import { useQuery } from "@tanstack/react-query";

export const useEmployees = () => {
  return useQuery({
    queryKey: ["employees"],
    queryFn: () => getEmployees(),
    staleTime: 1000 * 60 * 60 * 24, // 24 heures
    gcTime: 24 * 60 * 60 * 1000, // 24 heures (garder longtemps pour offline)
    networkMode: "offlineFirst", // Essaie le cache d'abord si offline
  });
};
